import { useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import Link from "src/components/buttons/LinkButton";
import Breadcrumbs from "src/components/layout/Breadcrumbs";
import Container from "src/components/layout/Container";
import Section from "src/components/layout/Section";
import { StoreProps, useStore } from "src/stores/Store";
import helmet from "src/utils/helmet";

interface Props extends StoreProps, RouteComponentProps<any> {}

export default function Store(props: Props) {
  const store = useStore();
  useEffect(() => {
    helmet.setPageTitle("Store");
  }, []);

  return (
    <Section noPadding={store.isAccountArea}>
      <Container>
        {store.isAccountArea && (
          <Breadcrumbs>
            <Link to={`/account`}>Home</Link> /{" "}
            <strong>{store.organization.title} Store</strong>
          </Breadcrumbs>
        )}
        <h1>{store.organization.title} Store</h1>

        <p className="text-empty">
          There are no items currently available for purchase.
        </p>
      </Container>
    </Section>
  );
}
